import { render, staticRenderFns } from "./BarcodeReader.vue?vue&type=template&id=65493f0d&"
import script from "./BarcodeReader.vue?vue&type=script&lang=js&"
export * from "./BarcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeReader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports